import { intervalToDuration } from 'date-fns'

type AvailableFormats = Record<string, string>

type DateFormatOptions = Partial<{
  ignoreYears: boolean
  ignoreMonths: boolean
  ignoreDays: boolean
  ignoreHours: boolean
  ignoreMinutes: boolean
  ignoreSeconds: boolean
}>

type GetIntervalParams = {
  start?: Date | string
  end?: Date | string
  // Aceita tanto uma chave pré-definida (ex.: "medicalRecords") quanto um formato customizado (ex.: "YY-MM-DD")
  format?: string
  options?: DateFormatOptions
}

export function getInterval({ start, end, format = 'medicalRecords', options }: GetIntervalParams): string {
  if (!start) return ''

  const raw = intervalToDuration({
    start: new Date(start),
    end: new Date(end ?? Date.now()),
  })

  // Normaliza campos opcionais do Duration para números
  const interval = {
    years: raw.years ?? 0,
    months: raw.months ?? 0,
    days: raw.days ?? 0,
    hours: raw.hours ?? 0,
    minutes: raw.minutes ?? 0,
    seconds: raw.seconds ?? 0,
  }

  const availableFormats: AvailableFormats = {
    medicalRecords: `${interval.years}A ${interval.months}M ${interval.days}D`,
  }

  const defaultFormat = `há ${interval.years && !options?.ignoreYears ? `${interval.years} anos` : ''} ${
    interval.months && !options?.ignoreMonths ? `${interval.months} meses` : ''
  } ${interval.days && !options?.ignoreDays ? `${interval.days} dias` : ''} ${
    interval.hours && !options?.ignoreHours ? `${interval.hours} horas` : ''
  } ${interval.minutes && !options?.ignoreMinutes ? `${interval.minutes} minutos` : ''} ${
    interval.seconds && !options?.ignoreSeconds ? `${interval.seconds} segundos` : ''
  }`
    .replace(/\s+/g, ' ')
    .trim()

  let output: string

  if (format) {
    if (Object.prototype.hasOwnProperty.call(availableFormats, format)) {
      output = availableFormats[format]
    } else {
      // Formato customizado, ex.: "YY anos, MM meses, DD dias"
      output = format
        .replace(/YY/g, String(interval.years))
        .replace(/MM/g, String(interval.months))
        .replace(/DD/g, String(interval.days))
        .replace(/hh/g, String(interval.hours))
        .replace(/mm/g, String(interval.minutes))
        .replace(/ss/g, String(interval.seconds))
    }
  } else {
    output = defaultFormat
  }

  return output
}
